import {h, Fragment} from "preact"
import Product from "./Product"
import { useAppState } from "@nosto/preact"
import { useEffect } from "preact/hooks";

export default function Products() {
    const {
        response: { products },
        loading
    } = useAppState()

    console.log("Products", products)


    useEffect(() => {
        yotpo.refreshWidgets();

        // Nosto.migrateToShopifyMarket({
        //     productSectionElement: '.ns-products-wrapper .nosto-product-info',
        //     productTitleElement: '.ns-products-wrapper .x-nosto-title',
        //     productHandleAttribute: 'x-nosto-handle',
        //     priceElement: '.ns-products-wrapper .nosto-newprice',
        //     listPriceElement: '.ns-products-wrapper .nosto-oldprice',
        // })
    })   
    
    return (
        <div class="ns-products-wrapper" style={loading ? "opacity: 0.3;" : ""}>
            {products.hits.map((hit, index) => {
                return <Product product={hit} key={hit.productId || index} />
            })}
        </div>
    )
}
